<template>
  <div class="tw-py-1 tw-text-right">{{ formattedValue }}</div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  format?: 'text' | 'number'
  value?: string | number | null
}

const props = withDefaults(defineProps<Props>(), {
  format: 'number',
  value: 0,
})

const formattedValue = computed(() => {
  const numberValue =
    typeof props.value === 'string' && props.value !== ''
      ? Number.parseFloat(props.value)
      : props.value

  return new Intl.NumberFormat(window.Silverfin.currentUserLocale(), {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numberValue || 0)
})
</script>
